import { render, staticRenderFns } from "./ImportNewFormFrGroup.vue?vue&type=template&id=b83dcb76"
import script from "./ImportNewFormFrGroup.vue?vue&type=script&lang=js"
export * from "./ImportNewFormFrGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports